import "./Footer.css";

const Footer = () => {
  return (
    <>
      <div className="footer">
        <p>🔴Copyright &copy; Ritika Khanduri 🔴</p>
      </div>
    </>
  );
};

export default Footer;
